import { FacetKey, FacetSuggestionResponse } from "../types/facets";
import { apiUrl } from "./api";

export async function fetchFacetSuggestions(facet: FacetKey, q: string, limit = 10): Promise<string[]> {
  const url = apiUrl("/feed/facets");
  url.searchParams.set("facet", facet);
  url.searchParams.set("q", q);
  url.searchParams.set("limit", String(limit));

  const response = await fetch(url.toString());
  if (!response.ok) {
    const message = await extractErrorMessage(response);
    throw new Error(message);
  }

  const json = (await response.json()) as FacetSuggestionResponse;
  return Array.isArray(json.values) ? json.values : [];
}

async function extractErrorMessage(response: Response): Promise<string> {
  try {
    const data = await response.json();
    if (data && typeof data === "object" && "error" in data && typeof data.error === "string") {
      return data.error;
    }
  } catch (error) {
    // ignore
  }

  return `Request failed with status ${response.status}`;
}
